<template>
  <div class="content background1">
    <iframe src="http://10.200.0.11:92/static/userList.html" frameborder="0" style="width: 100%;height: 100%"></iframe>
  </div>
</template>

<script>
    export default {
        name: "ceshi"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ceshi/ceshi2.vue